import React, {useState} from "react";
import PropTypes from "prop-types";
import InputMask from "react-input-mask";
import apiUser from "../apiUser";
import {isEmpty} from "lodash";
import {toast} from "react-toastify";
import {
  FormFeedback,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Tooltip
} from "reactstrap";
import {COUNTRY_CODE_PL} from "../utils/country";
import {useTranslation} from "react-i18next";
import classnames from "classnames";
import CountryCodeDropdown from "./CountryCodeDropdown";
import useAfterUpdateEffect from "../utils/useAfterUpdateEffect";

export default function InputMaskNip(props) {
  const { t } = useTranslation('tax_input');
  const [countryCode, setCountryCode] = React.useState(props?.countryCode);
  const [number, setNumber] = React.useState(props.number);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [searching, setSearching] = useState(false);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
  const onChange = (e) => setNumber(e.target.value.replace(/[^0-9\w\d.]+/g, ''));
  const onKeyUp = (e) => {
    switch (e.key) {
      case 'Enter': {
        if(props.onFindGusData){
          search();
        }

        break;
      }
      default:
        break;
    }
  };

  React.useEffect(() => props.onChange({number, countryCode}), [number, countryCode]);

  useAfterUpdateEffect(() => {
    if(props?.countryCode !== countryCode){
      setCountryCode(props?.countryCode);
    }
  }, [props?.countryCode])

  const getMask = () => {
    switch(countryCode) {
      case COUNTRY_CODE_PL: {
        return "999-999-99-99";
      }
      default: {
        return null
      }
    }
  }

  const search = () => {
    setSearching(true);

    apiUser.gus.find({nip: number})
    .then(gusData => {
      setSearching(false);
      if(!isEmpty(gusData)){
        props.onFindGusData(gusData);
      }else{
        toast.warn(t('search_empty'));
      }
    })
    .catch(() => {
      setSearching(false);
    })
  };

  return <InputGroup size={props.size}>
    {props.countryCodeDisplay && <InputGroupAddon addonType={'prepend'}>
      <CountryCodeDropdown
          type={'flag'}
          countryCode={countryCode}
          onChange={setCountryCode}
      />
    </InputGroupAddon>}
    <InputMask
        autoFocus
        className={classnames({
          'form-control': true,
          'is-invalid': !!props.errorMsg,
        })}
        mask={getMask()}
        placeholder={t('placeholder')}
        onChange={onChange}
        onKeyUp={onKeyUp}
        value={number}
    />
    {props.onFindGusData && <React.Fragment>
      <InputGroupAddon
          addonType="append"
          id={'nip-search'}
          className="cursor-pointer"
          onClick={search}>
        <InputGroupText>
          {searching
              ? <i>{t('searching')}</i>
              : <span><i className="fas fa-search pr-1"/></span>
          }
        </InputGroupText>
      </InputGroupAddon>
      <Tooltip placement="bottom" isOpen={tooltipOpen} target={'nip-search'}
               toggle={toggleTooltip}>{t('btn_text')}</Tooltip>
    </React.Fragment>}
    <FormFeedback>{props.errorMsg}</FormFeedback>
  </InputGroup>
};

InputMaskNip.defaultProps = {
  number: '',
  size: 'md',
  countryCodeDisplay: false,
};

InputMaskNip.propTypes = {
  size: PropTypes.string,
  countryCode: PropTypes.string,
  number: PropTypes.string,
  onFindGusData: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  countryCodeDisplay: PropTypes.bool,
  errorMsg: PropTypes.string,
};
